<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-basicsedit"
    title="编辑"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
  >
    <el-form :model="formData" :rules="rules" ref="modifyForm">
      <el-form-item class="select-input" label='平台' prop="mid_table_remark_001">
        <el-select disabled v-model="formData.mid_table_remark_001" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='粉丝数量' prop="mid_table_remark_002">
        <el-input
          class="custom-input"
          v-model="formData.mid_table_remark_002"
          placeholder="请输入报价金额"
          maxlength="11"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item class="upload-input" label='上传截图 文件格式：png/jpg' prop="mid_table_remark_003">
          <el-upload
            class="upload-input-inner"
            action="no"
            accept=".png,.jpg,.jpeg"
            :auto-upload="false"
            :multiple="false"
            :show-file-list="false"
            :on-change="
              (file, fileList) => {
                handleChange(file, fileList, 'add');
              }
            "
          >
            <div v-if="formData.mid_table_remark_003" class="inner-text">已上传</div>
            <div v-else class="inner-icon"></div>
            <el-input style="visibility:hidden" v-model="formData.mid_table_remark_003" placeholder="请上传截图" />
          </el-upload>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="custom-button btn-e0e0e0" @click="handleCloseDialog"
      >取消
      </el-button
      >
      <el-button class="custom-button btn-determine" @click="handleSubmit"
      >确定
      </el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { Base64 } from "js-base64";
import {positiveIntegerValidator} from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
import platformApi from "@/api/platform";
import accountApi from "@/api/account";
export default {
  name: "QuotedPrice",
  mixins: [],
  props: ['editInfo','userInfo'],
  data() {
    return {
      showDialog: false,
      formData: {
        mid_table_remark_001: null,
        mid_table_remark_002: null,
        mid_table_remark_003: null
      },
      rules: {
        mid_table_remark_001: [
          {required: true, message: "请选择平台", trigger: "change"}
        ],
        mid_table_remark_002: [
          {required: true, message: "请填写粉丝量", trigger: "blur"},
          {validator: positiveIntegerValidator, trigger: "blur"}
        ],
        mid_table_remark_003: [
          {required: true, message: "请填写报价", trigger: "change"}
        ]
      },
      options: [
        {
          value: '1001',
          label: '知乎'
        }, {
          value: '1002',
          label: 'CSDN'
        }, {
          value: '1003',
          label: '抖音'
        }, {
          value: '1004',
          label: '快手'
        }, {
          value: '1005',
          label: '西瓜视频'
        }, {
          value: '1006',
          label: '微信视频'
        }, {
          value: '1007',
          label: 'B站'
        }, {
          value: '1008',
          label: '今日头条'
        }, {
          value: '1009',
          label: '网易新闻'
        }, {
          value: '1010',
          label: '其他'
        }
      ],
      isRequesting: false,
    };
  },
  watch:{
    editInfo:{
        handler(val){
          if(val&&val.id_public_middle_table){
            this.formData={
              mid_table_remark_001: val.mid_table_remark_001,
              mid_table_remark_002: val.mid_table_remark_002,
              mid_table_remark_003: val.mid_table_remark_003,
            }
          };
        },
        immediate:true
    }
},
  mounted() {
  },
  methods: {
    handleCloseDialog: function () {
      let _this = this;
      _this.showDialog = false;
    },
    handleChange: function (file, fileList) {
      let _this = this;
      let data = this.$cookies.get("ossParams");
      if (!data) {
        _this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        _this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      _this.$uploadNormal(data, file, false).then(
        (res) => {
          this.$set(_this.formData, 'mid_table_remark_003', res)
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleSubmit: function () {
      let _this = this;
      let number=0;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      if (this.editInfo.id_public_middle_table&&this.userInfo.id_public_user_info) {
        _this.$refs["modifyForm"].validate((valid) => {
          if (valid) {
            let requestData = {
              isloading: true,
              mid_table_remark_002: _this.formData.mid_table_remark_002,
              mid_table_remark_003: _this.formData.mid_table_remark_003,
              mid_table_remark_004: 4001,
              id_public_middle_table: _this.editInfo.id_public_middle_table,
            }
            let requestNumberData = {
              begin_idx: 0,
              limit: 100,
              id_public_user_info: this.userInfo.id_public_user_info,
              mid_table_remark_004: 4002,
              isloading: true,
            };
            pageCommon.apiRequestCommon(platformApi, "insertPlatformData", requestData).then(
              (res) => {
                pageCommon.apiRequestCommon(platformApi, "getPlatformData", requestNumberData).then(
                  (res) => {
                  for (let j = 0; j < res.page_content.length; j++) {
                    if(res.page_content[j].mid_table_remark_004==4002){
                      number=number+Number(res.page_content[j].mid_table_remark_002)
                    }
                  }
                  let requestUserData = {
                    id_public_user_info: this.userInfo.id_public_user_info,
                    user_remark_021: number,
                    isloading: true,
                  };
                  pageCommon.apiRequestCommon(accountApi, "changeUerInfo", requestUserData).then(
                    (res) => {
                      _this.isRequesting = false;
                      _this.$store.dispatch("acUser", res.public_user_info);
                      storage.set("user", JSON.stringify(res.public_user_info));
                      _this.showDialog = false;
                    },
                    (err) => {
                      _this.isRequesting = false;
                      if (err.sysUserLoginError) {
                        _this.$message.error("系统异常，请稍后刷新重试！");
                      } else {
                      }
                    }
                  );
                },
                (err) => {
                  _this.isRequesting = false;
                  if (err.sysUserLoginError) {
                    _this.$message.error("系统异常，请稍后刷新重试！");
                  } else {
                  }
                }
              );
              },
              (err) => {
                _this.isRequesting = false;
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.$message.error(err.data.msg);
                }
              }
            );
          } else {
            _this.isRequesting = false;
          }
        });
      } else {
        _this.$message.error("页面异常，请稍后刷新重试！");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-basicsedit {
  /deep/ .el-dialog {
    position: absolute;
    width: 540px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 40px 40px;
      box-sizing: border-box;
      .el-dialog__title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
        text-align: left;
      }
      .el-dialog__headerbtn {
        position: relative;
        width: 16px;
        height: 16px;
        overflow: hidden;
        background: url("../../assets/icon_dialog_delete.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 0;
        .el-dialog__close {
          &::before {
            content: none;
          }
        }
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      padding: 0px 40px 0;
      box-sizing: border-box;
    }
    .el-form-item {
      display:block;
      margin-bottom:24px;
      .el-form-item__label{
        margin-bottom:6px;
        display:block;
        float:none;
        text-align:left;
        text-align:left;
        font-size:12px;
        color:#999999;
        line-height:1.2em;
      }
      .el-select{
        width:100%;
      }
    }
  }
  .upload-input{
    display:flex;
    flex-direction:row;
    .el-form-item__content{
      display:flex;
      flex-direction:row;
      .upload-input-inner{
        position:relative;
        width:70px;
        height:70px;
        border:1px dashed #CCCCCC;
        border-radius:4px;
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:center;
        align-content:center;
        align-content: flex-end;
        .inner-icon{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width: 24px;
            height: 24px;
            background-size: 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(~@/assets/edit_uploading_icon.png);
          }
          .inner-text{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width:70px;
          }
      }
      .inner-tip{
        margin-left:19px;
        margin-top:60px;
        line-height:1.2em;
        font-size: 12px;
        color:#999;
      }
    }
  }
  /deep/ .el-dialog__footer {
    position: relative;
    width: 100%;
    padding: 0;
    padding-bottom: 30px;
    /* padding-top: 0; */
    padding-right: 40px;
  }
  /deep/ .dialog-footer {
    display: flex;
    justify-content: flex-end;
    .custom-button {
      width: 80px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      margin-left: 25px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
